import React from 'react';
import { Apple, Smartphone } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';

const Home = () => {
  const handleDownload = (platform) => {
    console.log(`Download for ${platform} clicked`);
    // Placeholder for actual store links
  };

  return (
    <div className="home-container">
      {/* Hero Section */}
      <div className="hero-section">
        <div className="content-wrapper">
          {/* Logo/App Name */}
          <div className="app-branding">
            <h1 className="app-name">Yappr</h1>
            <p className="tagline">yap yap yap yap yap</p>
          </div>

          {/* Download Buttons */}
          <div className="download-buttons">
            <Button 
              className="download-btn ios-btn"
              onClick={() => handleDownload('iOS')}
            >
              <Apple className="btn-icon" />
              <span>Download on iPhone</span>
            </Button>
            <Button 
              className="download-btn android-btn"
              onClick={() => handleDownload('Android')}
            >
              <Smartphone className="btn-icon" />
              <span>Download on Android</span>
            </Button>
          </div>

          {/* App Screenshots */}
          <div className="screenshots-container">
            <div className="screenshot-wrapper">
              <img 
                src="https://customer-assets.emergentagent.com/job_54fd9f4a-414e-43eb-b78a-07f6853802d5/artifacts/8an9j1bu_01.png" 
                alt="Yappr app screenshot 1"
                className="app-screenshot"
              />
            </div>
            <div className="screenshot-wrapper">
              <img 
                src="https://customer-assets.emergentagent.com/job_54fd9f4a-414e-43eb-b78a-07f6853802d5/artifacts/hnyrzzc4_02.png" 
                alt="Yappr app screenshot 2"
                className="app-screenshot"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          <p className="footer-text">© 2025 Yappr Inc. All rights reserved.</p>
          <div className="footer-links">
            <Link to="/terms" className="footer-link">
              Terms of Service
            </Link>
            <span className="footer-divider">|</span>
            <Link to="/privacy" className="footer-link">
              Privacy Policy
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;